import { render } from "./AccessoryTypes.vue?vue&type=template&id=47d4774b"
import script from "./AccessoryTypes.vue?vue&type=script&lang=js"
export * from "./AccessoryTypes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__